import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActionReducerMap, StoreModule} from "@ngrx/store";
import {appReducers} from "./reducers/app.reducers";
import {TasksService2} from "./services/tasks-service2.service";
import {AccountingService} from "./services/accounting.service";
import {OsaService} from "./services/osa.service";
import {DictionaryService} from "./services/dictionary.service";
import {IAppState} from "./state/app.state";
export const REDUCER_TOKEN = new InjectionToken<ActionReducerMap<IAppState>>('root reducer');

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
//    StoreModule.forRoot(appReducers),
    //StoreModule.forRoot(REDUCER_TOKEN),
//    StoreModule.forRoot({system: viewElementsReducers}),

    // EffectsModule.forRoot([
    //   AuthenticationEffects,
    //   AuthenticatedUserEffects,
    //   TasksListEffects,
    //   AccountingEffects,
    //   InsightsEffects,
    //   PartnersEffects,
    //   AccountOperationsEffects,
    //   ResourcesEffects,
    //   LanguageEffects,
    //   OsaScanningEffects,
    //
    //   AppParametersEffects,
    //
    //   MdmEffects,
    //
    //   DisplayModeEffects,
    //   ViewModeEffects,
    //
    //   ConfigurationEffects,
    //   MarketplaceEffects
    //
    // ]),
    //DeviceDetectorModule.forRoot()

  ],
  providers: [
    TasksService2,
    AccountingService,
    OsaService,
    DictionaryService,


    {
      provide: REDUCER_TOKEN,
      useValue: appReducers
    }
  ]

})
export class AppStoreModule {
  constructor() {
    console.log('AppStore module loaded.');
  }
  static forRoot():ModuleWithProviders<AppStoreModule> {
    return {
      ngModule:AppStoreModule
    };
  }
}


